import { Backbone } from "extensions/backbone";

// Column types
import * as cells from "./cells/_all";

const DEFAULT_WIDTH = 150;

export const ColumnsCollection = Backbone.Collection.extend({
    // Allow node collection to contain different model types
    model: function model(attrs, options) {
        let cellType = typeof attrs.cell === "function" ? attrs.cell(attrs) : attrs.cell;
        
        // Add default type as `text`
        if (!cellType) {
            cellType = "text";
            attrs.cell = "text";
        }
        
        // eslint-disable-next-line eqeqeq
        if (cells[cellType] != null) {
            return new cells[cellType].Model(attrs, options);
        }
        
        throw new Error(`Unsupported type: ${cellType}`);
    },
    
    getTotalWidth() {
        return this.reduce((memo, model) => {
            if (model.get("cellClassName") === "exportOnly") {
                return memo;
            }
            return memo + (model.get("width") || DEFAULT_WIDTH);
        }, 0);
    }
});
